import { lazy, Suspense } from "react";
import { Navigate, createBrowserRouter } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary"; // Make sure to create this component
import Loader from "../components/Loader"; 


const DocsList = lazy(() => import("../pages/docs/DocsList"));
const LinkedRecords = lazy(() => import("../pages/docs/LinkedRecords"));
// const ArtworkEdit = lazy(() => import("../pages/docs/ArtworkEdit"));
// const ArtworkAdd = lazy(() => import("../pages/docs/ArtworkAdd"));



const routesForm = [
  {
    path: "*",
    element: (
      <Navigate to="/docs" />
    ),
  },
  {
    path: "/docs",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <DocsList />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  {
    path: "/docs/linkedrecords",
    element: (
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          <LinkedRecords />
        </Suspense>
      </ErrorBoundary>
    ),
  },
  // {
  //   path: "/artwork/edit-label",
  //   element: (
  //     <ErrorBoundary>
  //       <Suspense fallback={<Loader />}>
  //          <ArtworkEdit /> 
  //       </Suspense>
  //     </ErrorBoundary>
  //   ),
  // },
  // {
  //   path: "/artwork/add-label",
  //   element: (
  //     <ErrorBoundary>
  //       <Suspense fallback={<Loader />}>
  //        <ArtworkAdd/> 
  //       </Suspense>
  //     </ErrorBoundary>
  //   ),
  // },
];

const Router = createBrowserRouter(routesForm);

export { Router };